// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadCrumbs_container__3Y4la","label":"BreadCrumbs_label__1dtcy","arrow":"BreadCrumbs_arrow__AJOgw","arrow_word":"BreadCrumbs_arrow_word__3LuLY"};